import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import {POLL_AND_QUIZ_SUBTYPE} from '../../constants/appConstants';
import Radio from '@mui/material/Radio';
import FormControl from '@mui/material/FormControl';
import * as React from 'react';

export default function SubTypeSelection({subType, setSubType}) {
  return <FormControl>
    <RadioGroup
      aria-labelledby="demo-radio-buttons-group-label"
      defaultValue="text"
      name="radio-buttons-group"
      row
      onChange={(event, value) => {
        setSubType(value)
      }}
      value={subType}
    >
      <FormControlLabel value={POLL_AND_QUIZ_SUBTYPE.TEXT} control={<Radio/>}
                        label={POLL_AND_QUIZ_SUBTYPE.TEXT}/>
      <FormControlLabel value={POLL_AND_QUIZ_SUBTYPE.IMAGE} control={<Radio/>}
                        label={POLL_AND_QUIZ_SUBTYPE.IMAGE}/>
    </RadioGroup>

  </FormControl>
}